/** @jsxImportSource theme-ui */
import React from 'react';
import { Box } from '@infotrack/zenith-ui';
import type { ITopFiveApiV2EndpointsStaffSharedModelsStaffItemDto } from '@/api/models';
import {
  cardStyles,
  nameStyles,
  emailStyles,
  infoRowStyles,
  labelStyles,
  valueStyles,
  badgeContainerStyles,
  inactiveBadgeStyles,
  managerBadgeStyles,
  executiveBadgeStyles,
} from './staffCard.styles';

interface StaffCardProps {
  staff: ITopFiveApiV2EndpointsStaffSharedModelsStaffItemDto;
  onClick: (id: number) => void;
}

export const StaffCard: React.FC<StaffCardProps> = ({ staff, onClick }) => {
  return (
    <Box sx={cardStyles} onClick={() => onClick(staff.staffId ?? 0)}>
      <Box sx={nameStyles}>{staff.fullName}</Box>
      {staff.staffEmail && <Box sx={emailStyles}>{staff.staffEmail}</Box>}

      {staff.company && (
        <Box sx={infoRowStyles}>
          <Box sx={labelStyles}>Company</Box>
          <Box sx={valueStyles}>{staff.company}</Box>
        </Box>
      )}

      <Box sx={infoRowStyles}>
        {staff.department && (
          <>
            <Box sx={labelStyles}>Department</Box>
            <Box sx={valueStyles}>{staff.department}</Box>
          </>
        )}
      </Box>

      {staff.managerName && (
        <Box sx={infoRowStyles}>
          <Box sx={labelStyles}>Manager</Box>
          <Box sx={valueStyles}>{staff.managerName}</Box>
        </Box>
      )}

      <Box sx={badgeContainerStyles}>
        {!staff.isActive && (
          <Box sx={inactiveBadgeStyles}>Inactive</Box>
        )}
        {staff.isManager && (
          <Box sx={managerBadgeStyles}>Manager</Box>
        )}
        {staff.isExecutive && (
          <Box sx={executiveBadgeStyles}>Executive</Box>
        )}
      </Box>
    </Box>
  );
};
